import React from 'react'
import commonStyles from '../AddRecipient.styles';
import styles from "./GetRecipientType.styles"
import { RECIPIENT_TYPE, RECIPIENT_TYPE_1042_S } from './constants';
import Heading from "../../../../components/heading/Heading";
import { HEADING } from "../../../../components/heading/constants/constants";
import CardWIconTitleAndButton from "../../../../components/card/CardWIconTitleAndButton/CardWIconTitleAndButton"

export default function GetRecipientType({
    onCardClickCb = () => { },
    type = "",
    heading = "How would you describe this recipient?",
    description = "A recipient is someone who receives income or payments subject to taxation.",
    is1042SForm = false,
    renderForSingleView = false,
}) {

    const cards = is1042SForm ? RECIPIENT_TYPE_1042_S : RECIPIENT_TYPE;

    return (
        <>
            <div style={commonStyles.container}>
                <div>
                    <Heading type={HEADING.H1}>{heading}</Heading>
                    <p>{description}</p>
                </div>

                <div style={commonStyles.cardsGroupContainer}>

                    {
                        cards.map((card, idx) => (

                            <div style={commonStyles.cardContainer} onClick={() => onCardClickCb(card)}>
                                <CardWIconTitleAndButton
                                    title={card.title}
                                    icon={card.icon}
                                    customStyles={{...styles.individualCardStyle, ...(renderForSingleView ? styles.singleViewIndividualCardStyle : {})}}
                                    isHighlighted={type === card.title ? true : false}
                                    justifyContent="center"
                                    headerCustomStyles={{...styles.cardHeader, ...(renderForSingleView ? styles.singleViewCardHeader : {})}}
                                />
                            </div>

                        ))
                    }

                </div>
            </div>
        </>
    )
}